import http from './config'

export default {
  usuarioExiste: (dadosPrincipal, gRecaptchaResponse) => {
    return http.post('/api/v1/auth/usuario-existe', dadosPrincipal, {
      headers: {
        'g-recaptcha-response': gRecaptchaResponse
      }
    })
  },
  login: (username, password) => {
    const formData = new URLSearchParams()
    formData.append('username', username)
    formData.append('password', password)
    const resp = http.post('/api/v1/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded' // Set the content type
      }
    })
    resp.then(resposta => {
      localStorage.setItem('Token_CAPAF', resposta.data.token)
      localStorage.setItem('Refresh_Token_CAPAF', resposta.data.refreshToken)
    })
    return resp
  }
}
